import { create } from 'zustand';
import { combine } from 'zustand/middleware';

const initialState = {
  title: '',
  description: '',
  cancelText: '',
  confirmText: '',
  visible: false,
};

export const useConfirmationDialogStore = create(
  combine(initialState, set => ({
    onCancel: () => {
      set({ visible: false });
    },
    onConfirm: () => {
      set({ visible: false });
    },
    onBackdropClick: () => {
      set({ visible: false });
    },
    reset: () => {
      set(initialState);
    },
  })),
);

function reset() {
  useConfirmationDialogStore.setState(initialState);
  useConfirmationDialogStore.setState({
    onCancel: () => {
      useConfirmationDialogStore.setState({ visible: false });
    },
    onConfirm: () => {
      useConfirmationDialogStore.setState({ visible: false });
    },
    onBackdropClick: () => {
      useConfirmationDialogStore.setState({ visible: false });
    },
  });
}

export function showConfirmationDialog(
  title: string,
  description: string,
  confirmText: string,
  cancelText: string,
  onConfirm: () => void = () => {},
  onCancel: () => void = () => {},
) {
  useConfirmationDialogStore.setState({
    title,
    description,
    confirmText,
    cancelText,
    onConfirm: () => {
      onConfirm();
      reset();
    },
    onCancel: () => {
      onCancel();
      reset();
    },
    visible: true,
  });
}
